export const reasonRejected = [
  'content.printProof.reasonRejected.replaceText',
  'content.printProof.reasonRejected.changeFont',
  'content.printProof.reasonRejected.printColorChange',
  'content.printProof.reasonRejected.repositionLogo',
  'content.printProof.reasonRejected.changeLogoFormat',
  'content.printProof.reasonRejected.changeLogo',
  'content.printProof.reasonRejected.changePrintOption',
  'content.printProof.reasonRejected.changeProduct',
  'content.printProof.reasonRejected.changeProductVariant',
];
